import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { WebflowLoginFlowControllerPage } from './webflow-login-flow-controller.page';
import { WebflowLoginFlowControllerPageRoutingModule } from './webflow-login-flow-controller-routing.module';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, WebflowLoginFlowControllerPageRoutingModule],
  declarations: [WebflowLoginFlowControllerPage],
})
export class WebflowLoginFlowControllerPageModule {}
